var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicStartButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18374",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18374",
    transform: "translate(17659 1983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18373",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18373",
    transform: "translate(12 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_5508",
    "data-name": "\\u6955\\u5186\\u5F62 5508",
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    transform: "translate(-17671 -1986)",
    fill: "#9f9f9f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u591A\\u89D2\\u5F62_268",
    "data-name": "\\u591A\\u89D2\\u5F62 268",
    d: "M12.272,2.962a2,2,0,0,1,3.455,0L26.245,20.992A2,2,0,0,1,24.518,24H3.482a2,2,0,0,1-1.728-3.008Z",
    transform: "translate(-17611 -1964) rotate(90)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicStartButton);
export default __webpack_public_path__ + "static/media/musicStartButton.a08fc8d03e10461bea22a01c41c0c9b8.svg";
export { ForwardRef as ReactComponent };